// Minimaler iCalendar-(.ics-)Generator für Aufgaben-Wiedervorlagen.
// Erzeugt Ganztags-VEVENTs; clientseitig, ohne Abhängigkeit.

export interface IcsTask {
  uid: string;
  summary: string;
  date: string; // 'YYYY-MM-DD'
  description?: string;
  url?: string;
}

function escapeText(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
}

function stamp(): string {
  return new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

export function buildIcs(tasks: IcsTask[]): string {
  const lines: string[] = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//FeWo-Monitor//Aufgaben//DE',
    'CALSCALE:GREGORIAN',
  ];
  const now = stamp();
  for (const t of tasks) {
    const dt = t.date.replace(/-/g, ''); // YYYYMMDD (all-day)
    lines.push('BEGIN:VEVENT');
    lines.push(`UID:${t.uid}`);
    lines.push(`DTSTAMP:${now}`);
    lines.push(`DTSTART;VALUE=DATE:${dt}`);
    lines.push(`SUMMARY:${escapeText(t.summary)}`);
    const desc = [t.description, t.url].filter(Boolean).join('\n');
    if (desc) lines.push(`DESCRIPTION:${escapeText(desc)}`);
    if (t.url) lines.push(`URL:${t.url}`);
    lines.push('END:VEVENT');
  }
  lines.push('END:VCALENDAR');
  return lines.join('\r\n');
}

export function downloadIcs(filename: string, tasks: IcsTask[]): void {
  const blob = new Blob([buildIcs(tasks)], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
